import { type FC } from 'react';

import { Select, type SelectProps } from '@/components/common/select/Select';

type AreaSelectProps = Omit<SelectProps<string>, 'options'>;

const OPTIONS = [
  { value: '0 - 100 000' },
  { value: '100 000 - 500 000' },
  { value: '500 000 - 1 500 000' },
  { value: '> 1 500 000' },
];

export const MonthTurnoverSelect: FC<AreaSelectProps> = (props) => {
  return <Select options={OPTIONS} {...props} />;
};
